import { colors } from '@/theme/colors';

export default function CalculatorSalesPitchV2Gradient() {
  return (
    <svg
      width="400"
      height="308"
      viewBox="0 0 400 308"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4" filter="url(#filter0_f_3443_17697)">
        <path
          d="M422.004 210.771C422.004 301.77 297.406 316 209.904 316C122.402 316 105.131 240.945 105.131 210.771C105.131 180.597 -46.6613 162.636 263.567 156.136C483.845 153.853 422.004 180.597 422.004 210.771Z"
          fill="url(#paint0_linear_3443_17697)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_3443_17697"
          x="-88"
          y="0"
          width="674"
          height="472"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="78" result="effect1_foregroundBlur_3443_17697" />
        </filter>
        <linearGradient
          id="paint0_linear_3443_17697"
          x1="109.563"
          y1="359.679"
          x2="229.726"
          y2="0.846802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.sunsetBlue} />
          <stop offset="0.643637" stopColor={colors.sunsetPurple} />
          <stop offset="0.893108" stopColor={colors.sunsetPink} />
        </linearGradient>
      </defs>
    </svg>
  );
}
